import {
  addUniqueValueToArray
} from 'utils/redux'

export const NAMESPACE = 'KanBo/documentTemplateSources/'
export const SET_LOAD_STATUS = NAMESPACE + 'SET_LOAD_STATUS'
export const ADD = NAMESPACE + 'ADD'
export const ADD_ARRAY = NAMESPACE + 'ADD_ARRAY'
export const REMOVE = NAMESPACE + 'REMOVE'
export const SET_CURSOR = NAMESPACE + 'SET_CURSOR'

const initialState = {
  ids: [],
  byId: {},
  cursor: null,
  isLoading: false,
  isLoaded: false
}

const documentDefaults = {
  boards: [],
  isLoaded: false,
  isBusy: false
}

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case SET_LOAD_STATUS:
      return {
        ...state,
        isLoading: action.payload.isLoading,
        isLoaded: action.payload.isLoaded
      }
    case ADD:
      return {
        ...state,
        ids: addUniqueValueToArray({
          array: state.ids,
          value: action.payload.id,
          index: action.payload.index
        }),
        byId: {
          ...state.byId,
          [action.payload.id]: {
            ...documentDefaults,
            ...action.payload
          }
        }
      }
    case ADD_ARRAY: {
      const newState = {
        ...state,
        ids: [ ...state.ids ],
        byId: { ...state.byId }
      }
      action.payload.forEach(item => {
        newState.ids = addUniqueValueToArray({
          array: newState.ids,
          value: item.id,
          index: item.index
        })
        newState.byId[item.id] = {
          ...documentDefaults,
          ...item
        }
      })
      return newState
    }
    case REMOVE: {
      const newState = {
        ...state,
        ids: [ ...state.ids.filter(id => id !== action.payload.id) ],
        byId: { ...state.byId }
      }
      delete newState.byId[action.payload.id]
      return newState
    }
    case SET_CURSOR:
      return {
        ...state,
        cursor: action.payload
      }
    default: return state
  }
}

export function setLoadStatus ({ isLoading, isLoaded }) {
  return {
    type: SET_LOAD_STATUS,
    payload: {
      isLoading,
      isLoaded
    }
  }
}

export function add (data) {
  return {
    type: ADD,
    payload: data
  }
}

export function addArray (boardArray) {
  return {
    type: ADD_ARRAY,
    payload: boardArray
  }
}

export function remove ({ id }) {
  return {
    type: REMOVE,
    payload: {
      id
    }
  }
}

export function setCursor (payload) {
  return {
    type: SET_CURSOR,
    payload
  }
}
